import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css'

const rootElement = document.getElementById('root');

// react-snap поддержка
if (rootElement.hasChildNodes()) {
    // hydrate для pre-rendered контента
    ReactDOM.hydrateRoot(
        rootElement,
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
} else {
    // обычный render для разработки
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <BrowserRouter>
            <App />
        </BrowserRouter>
    );
}
